import { api } from '../../api';

export async function sendExternalFeedback(payload, org_id) {
  try {
    // check if devive_name is present in payload
    if (!payload.device_name || payload.device_name.trim() === "" || payload.device_name === null || payload.device_name === undefined || payload.device_name === "null" || payload.device_name === "undefined" ) {
      console.log("device_name not present in payload, fetching from backend");
      // fetch device_name from backend using device_id
      const res1 = await fetch(`${api}/device-name/${payload.device_id}`);
      if (res1.ok) {
        const data1 = await res1.json();
        if (data1.device_name) {
          payload.device_name = data1.device_name;
          console.log("Fetched device_name from backend:", data1.device_name);
          // also update in local storage
          localStorage.setItem('device_name', data1.device_name);
        } else {
          console.warn("device_name not found in backend response");
        }
      } else {
        console.error("Failed to fetch device_name from backend");
      }
    }
      // fetch device_name from backend using device_id
    const res = await fetch(`${api}/external-feedback/${org_id}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload)
    });

    if (!res.ok) {
      console.error("Backend error while processing external feedback");
      return { success: false };
    }

    const data = await res.json();
    return { success: true, data };
  } catch (err) {
    console.error("Network error:", err);
    return { success: false, error: err };
  }
}

export const getLocalDateTime = (date = new Date()) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  const ms = String(date.getMilliseconds()).padStart(3, '0');
  
  // Get timezone offset
  const tzOffset = -date.getTimezoneOffset(); // in minutes
  const offsetHours = Math.floor(Math.abs(tzOffset) / 60);
  const offsetMinutes = Math.abs(tzOffset) % 60;
  const offsetSign = tzOffset >= 0 ? '+' : '-';
  const offset = `${offsetSign}${String(offsetHours).padStart(2, '0')}:${String(offsetMinutes).padStart(2, '0')}`;
  
  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${ms}${offset}`;
}